import React from 'react';
import { FunctionComponent } from 'react';

import { TagContainer } from './styles';

interface TagProps {
  label: string;
  labelIcon?: FunctionComponent;
  content: string[]; // Content to show on hover (e.g., description or details)
}

const Tag: React.FC<TagProps> = ({ label, content, labelIcon: LabelIcon }) => {
  return (
    <TagContainer>
      <span className="tag-label">
        {label}
        {LabelIcon && (
          <>
            {' '}
            <LabelIcon aria-label="More information" />
          </>
        )}
      </span>
      <div className="tag-tooltip">
        {content.length && (
          <ul>
            {content.map((detail) => (
              <li>{detail}</li>
            ))}
          </ul>
        )}
      </div>
    </TagContainer>
  );
};

export default Tag;
